import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _dec87, _dec88, _dec89, _dec90, _dec91, _dec92, _dec93, _dec94, _dec95, _dec96, _dec97, _dec98, _dec99, _dec100, _dec101, _dec102, _dec103, _dec104, _dec105, _dec106, _dec107, _dec108, _dec109, _dec110, _dec111, _dec112, _dec113, _dec114, _dec115, _dec116, _dec117, _dec118, _dec119, _dec120, _dec121, _dec122, _dec123, _dec124, _dec125, _dec126, _dec127, _dec128, _dec129, _dec130, _dec131, _dec132, _dec133, _dec134, _dec135, _dec136, _dec137, _dec138, _dec139, _dec140, _dec141, _dec142, _dec143, _dec144, _dec145, _dec146, _dec147, _dec148, _dec149, _dec150, _dec151, _dec152, _dec153, _dec154, _dec155, _dec156, _dec157, _dec158, _dec159, _dec160, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97, _descriptor98, _descriptor99, _descriptor100, _descriptor101, _descriptor102, _descriptor103, _descriptor104, _descriptor105, _descriptor106, _descriptor107, _descriptor108, _descriptor109, _descriptor110, _descriptor111, _descriptor112, _descriptor113, _descriptor114, _descriptor115, _descriptor116, _descriptor117, _descriptor118, _descriptor119, _descriptor120, _descriptor121, _descriptor122, _descriptor123, _descriptor124, _descriptor125, _descriptor126, _descriptor127, _descriptor128, _descriptor129, _descriptor130, _descriptor131, _descriptor132, _descriptor133, _descriptor134, _descriptor135, _descriptor136, _descriptor137, _descriptor138, _descriptor139, _descriptor140, _descriptor141, _descriptor142, _descriptor143, _descriptor144, _descriptor145, _descriptor146, _descriptor147, _descriptor148, _descriptor149, _descriptor150, _descriptor151, _descriptor152, _descriptor153, _descriptor154, _descriptor155, _descriptor156, _descriptor157, _descriptor158, _descriptor159, _descriptor160;
let RoleModel = (_dec = attr('string'), _dec2 = attr('boolean'), _dec3 = attr('boolean'), _dec4 = attr('boolean'), _dec5 = attr('boolean'), _dec6 = attr('boolean'), _dec7 = attr('boolean'), _dec8 = attr('boolean'), _dec9 = attr('boolean'), _dec0 = attr('boolean'), _dec1 = attr('boolean'), _dec10 = attr('boolean'), _dec11 = attr('boolean'), _dec12 = attr('boolean'), _dec13 = attr('boolean'), _dec14 = attr('boolean'), _dec15 = attr('boolean'), _dec16 = attr('boolean'), _dec17 = attr('boolean'), _dec18 = attr('boolean'), _dec19 = attr('boolean'), _dec20 = attr('boolean'), _dec21 = attr('boolean'), _dec22 = attr('boolean'), _dec23 = attr('boolean'), _dec24 = attr('boolean'), _dec25 = attr('boolean'), _dec26 = attr('boolean'), _dec27 = attr('boolean'), _dec28 = attr('boolean'), _dec29 = attr('boolean'), _dec30 = attr('boolean'), _dec31 = attr('boolean'), _dec32 = attr('boolean'), _dec33 = attr('boolean'), _dec34 = attr('boolean'), _dec35 = attr('boolean'), _dec36 = attr('boolean'), _dec37 = attr('boolean'), _dec38 = attr('boolean'), _dec39 = attr('boolean'), _dec40 = attr('boolean'), _dec41 = attr('boolean'), _dec42 = attr('boolean'), _dec43 = attr('boolean'), _dec44 = attr('boolean'), _dec45 = attr('boolean'), _dec46 = attr('boolean'), _dec47 = attr('boolean'), _dec48 = attr('boolean'), _dec49 = attr('boolean'), _dec50 = attr('boolean'), _dec51 = attr('boolean'), _dec52 = attr('boolean'), _dec53 = attr('boolean'), _dec54 = attr('boolean'), _dec55 = attr('boolean'), _dec56 = attr('boolean'), _dec57 = attr('boolean'), _dec58 = attr('boolean'), _dec59 = attr('boolean'), _dec60 = attr('boolean'), _dec61 = attr('boolean'), _dec62 = attr('boolean'), _dec63 = attr('boolean'), _dec64 = attr('boolean'), _dec65 = attr('boolean'), _dec66 = attr('boolean'), _dec67 = attr('boolean'), _dec68 = attr('boolean'), _dec69 = attr('boolean'), _dec70 = attr('boolean'), _dec71 = attr('boolean'), _dec72 = attr('boolean'), _dec73 = attr('boolean'), _dec74 = attr('boolean'), _dec75 = attr('boolean'), _dec76 = attr('boolean'), _dec77 = attr('boolean'), _dec78 = attr('boolean'), _dec79 = attr('boolean'), _dec80 = attr('boolean'), _dec81 = attr('boolean'), _dec82 = attr('boolean'), _dec83 = attr('boolean'), _dec84 = attr('boolean'), _dec85 = attr('boolean'), _dec86 = attr('boolean'), _dec87 = attr('boolean'), _dec88 = attr('boolean'), _dec89 = attr('boolean'), _dec90 = attr('boolean'), _dec91 = attr('boolean'), _dec92 = attr('boolean'), _dec93 = attr('boolean'), _dec94 = attr('boolean'), _dec95 = attr('boolean'), _dec96 = attr('boolean'), _dec97 = attr('boolean'), _dec98 = attr('boolean'), _dec99 = attr('boolean'), _dec100 = attr('boolean'), _dec101 = attr('boolean'), _dec102 = attr('boolean'), _dec103 = attr('boolean'), _dec104 = attr('boolean'), _dec105 = attr('boolean'), _dec106 = attr('boolean'), _dec107 = attr('boolean'), _dec108 = attr('boolean'), _dec109 = attr('boolean'), _dec110 = attr('boolean'), _dec111 = attr('boolean'), _dec112 = attr('boolean'), _dec113 = attr('boolean'), _dec114 = attr('boolean'), _dec115 = attr('boolean'), _dec116 = attr('boolean'), _dec117 = attr('boolean'), _dec118 = attr('boolean'), _dec119 = attr('boolean'), _dec120 = attr('boolean'), _dec121 = attr('boolean'), _dec122 = attr('boolean'), _dec123 = attr('boolean'), _dec124 = attr('boolean'), _dec125 = attr('boolean'), _dec126 = attr('boolean'), _dec127 = attr('boolean'), _dec128 = attr('boolean'), _dec129 = attr('boolean'), _dec130 = attr('boolean'), _dec131 = attr('boolean'), _dec132 = attr('boolean'), _dec133 = attr('boolean'), _dec134 = attr('boolean'), _dec135 = attr('boolean'), _dec136 = attr('boolean'), _dec137 = attr('boolean'), _dec138 = attr('boolean'), _dec139 = attr('boolean'), _dec140 = attr('boolean'), _dec141 = attr('boolean'), _dec142 = attr('boolean'), _dec143 = attr('boolean'), _dec144 = attr('boolean'), _dec145 = attr('boolean'), _dec146 = attr('boolean'), _dec147 = attr('boolean'), _dec148 = attr('boolean'), _dec149 = attr('boolean'), _dec150 = attr('boolean'), _dec151 = attr('boolean'), _dec152 = attr('boolean'), _dec153 = attr('boolean'), _dec154 = attr('boolean'), _dec155 = attr('boolean'), _dec156 = attr('boolean'), _dec157 = attr('boolean'), _dec158 = belongsTo('application', {
  inverse: null,
  async: false
}), _dec159 = attr('string'), _dec160 = attr('boolean', {
  defaultValue: false
}), _class = class RoleModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "role_name", _descriptor, this);
    _initializerDefineProperty(this, "is_editable", _descriptor2, this);
    _initializerDefineProperty(this, "is_erasable", _descriptor3, this);
    _initializerDefineProperty(this, "is_show", _descriptor4, this);
    _initializerDefineProperty(this, "is_admin", _descriptor5, this);
    _initializerDefineProperty(this, "is_client", _descriptor6, this);
    _initializerDefineProperty(this, "show_user_online", _descriptor7, this);
    _initializerDefineProperty(this, "show_settings", _descriptor8, this);
    _initializerDefineProperty(this, "totals_view", _descriptor9, this);
    _initializerDefineProperty(this, "report_view", _descriptor0, this);
    _initializerDefineProperty(this, "hide_account_settings", _descriptor1, this);
    _initializerDefineProperty(this, "show_contact_dati", _descriptor10, this);
    _initializerDefineProperty(this, "hide_price_events", _descriptor11, this);
    _initializerDefineProperty(this, "hide_compensi", _descriptor12, this);
    _initializerDefineProperty(this, "hide_communication", _descriptor13, this);
    _initializerDefineProperty(this, "contact_view", _descriptor14, this);
    _initializerDefineProperty(this, "contact_view_all", _descriptor15, this);
    _initializerDefineProperty(this, "contact_view_join", _descriptor16, this);
    _initializerDefineProperty(this, "product_view_all", _descriptor17, this);
    _initializerDefineProperty(this, "product_view", _descriptor18, this);
    _initializerDefineProperty(this, "product_view_join", _descriptor19, this);
    _initializerDefineProperty(this, "project_view", _descriptor20, this);
    _initializerDefineProperty(this, "project_view_all", _descriptor21, this);
    _initializerDefineProperty(this, "project_view_join", _descriptor22, this);
    _initializerDefineProperty(this, "event_view", _descriptor23, this);
    _initializerDefineProperty(this, "event_view_all", _descriptor24, this);
    _initializerDefineProperty(this, "event_view_join", _descriptor25, this);
    _initializerDefineProperty(this, "workhour_view", _descriptor26, this);
    _initializerDefineProperty(this, "workhour_view_all", _descriptor27, this);
    _initializerDefineProperty(this, "workhour_view_join", _descriptor28, this);
    _initializerDefineProperty(this, "estimate_view", _descriptor29, this);
    _initializerDefineProperty(this, "estimate_view_all", _descriptor30, this);
    _initializerDefineProperty(this, "estimate_view_join", _descriptor31, this);
    _initializerDefineProperty(this, "invoice_view", _descriptor32, this);
    _initializerDefineProperty(this, "invoice_view_all", _descriptor33, this);
    _initializerDefineProperty(this, "invoice_view_join", _descriptor34, this);
    _initializerDefineProperty(this, "expense_view", _descriptor35, this);
    _initializerDefineProperty(this, "expense_view_all", _descriptor36, this);
    _initializerDefineProperty(this, "expense_view_join", _descriptor37, this);
    _initializerDefineProperty(this, "payment_view", _descriptor38, this);
    _initializerDefineProperty(this, "payment_view_all", _descriptor39, this);
    _initializerDefineProperty(this, "payment_view_join", _descriptor40, this);
    _initializerDefineProperty(this, "contact_insert", _descriptor41, this);
    _initializerDefineProperty(this, "contact_insert_all", _descriptor42, this);
    _initializerDefineProperty(this, "contact_insert_join", _descriptor43, this);
    _initializerDefineProperty(this, "product_insert", _descriptor44, this);
    _initializerDefineProperty(this, "product_insert_all", _descriptor45, this);
    _initializerDefineProperty(this, "product_insert_join", _descriptor46, this);
    _initializerDefineProperty(this, "project_insert", _descriptor47, this);
    _initializerDefineProperty(this, "project_insert_all", _descriptor48, this);
    _initializerDefineProperty(this, "project_insert_join", _descriptor49, this);
    _initializerDefineProperty(this, "event_insert", _descriptor50, this);
    _initializerDefineProperty(this, "event_insert_all", _descriptor51, this);
    _initializerDefineProperty(this, "event_insert_join", _descriptor52, this);
    _initializerDefineProperty(this, "workhour_insert", _descriptor53, this);
    _initializerDefineProperty(this, "workhour_insert_all", _descriptor54, this);
    _initializerDefineProperty(this, "workhour_insert_join", _descriptor55, this);
    _initializerDefineProperty(this, "estimate_insert", _descriptor56, this);
    _initializerDefineProperty(this, "estimate_insert_all", _descriptor57, this);
    _initializerDefineProperty(this, "estimate_insert_join", _descriptor58, this);
    _initializerDefineProperty(this, "invoice_insert", _descriptor59, this);
    _initializerDefineProperty(this, "invoice_insert_all", _descriptor60, this);
    _initializerDefineProperty(this, "invoice_insert_join", _descriptor61, this);
    _initializerDefineProperty(this, "expense_insert", _descriptor62, this);
    _initializerDefineProperty(this, "expense_insert_all", _descriptor63, this);
    _initializerDefineProperty(this, "expense_insert_join", _descriptor64, this);
    _initializerDefineProperty(this, "payment_insert", _descriptor65, this);
    _initializerDefineProperty(this, "payment_insert_all", _descriptor66, this);
    _initializerDefineProperty(this, "payment_insert_join", _descriptor67, this);
    _initializerDefineProperty(this, "contact_edit", _descriptor68, this);
    _initializerDefineProperty(this, "contact_edit_all", _descriptor69, this);
    _initializerDefineProperty(this, "contact_edit_join", _descriptor70, this);
    _initializerDefineProperty(this, "product_edit", _descriptor71, this);
    _initializerDefineProperty(this, "product_edit_all", _descriptor72, this);
    _initializerDefineProperty(this, "product_edit_join", _descriptor73, this);
    _initializerDefineProperty(this, "project_edit", _descriptor74, this);
    _initializerDefineProperty(this, "project_edit_all", _descriptor75, this);
    _initializerDefineProperty(this, "project_edit_join", _descriptor76, this);
    _initializerDefineProperty(this, "event_edit", _descriptor77, this);
    _initializerDefineProperty(this, "event_edit_all", _descriptor78, this);
    _initializerDefineProperty(this, "event_edit_join", _descriptor79, this);
    _initializerDefineProperty(this, "workhour_edit", _descriptor80, this);
    _initializerDefineProperty(this, "workhour_edit_all", _descriptor81, this);
    _initializerDefineProperty(this, "workhour_edit_join", _descriptor82, this);
    _initializerDefineProperty(this, "estimate_edit", _descriptor83, this);
    _initializerDefineProperty(this, "estimate_edit_all", _descriptor84, this);
    _initializerDefineProperty(this, "estimate_edit_join", _descriptor85, this);
    _initializerDefineProperty(this, "invoice_edit", _descriptor86, this);
    _initializerDefineProperty(this, "invoice_edit_all", _descriptor87, this);
    _initializerDefineProperty(this, "invoice_edit_join", _descriptor88, this);
    _initializerDefineProperty(this, "expense_edit", _descriptor89, this);
    _initializerDefineProperty(this, "expense_edit_all", _descriptor90, this);
    _initializerDefineProperty(this, "expense_edit_join", _descriptor91, this);
    _initializerDefineProperty(this, "payment_edit", _descriptor92, this);
    _initializerDefineProperty(this, "payment_edit_all", _descriptor93, this);
    _initializerDefineProperty(this, "payment_edit_join", _descriptor94, this);
    _initializerDefineProperty(this, "contact_delete", _descriptor95, this);
    _initializerDefineProperty(this, "contact_delete_all", _descriptor96, this);
    _initializerDefineProperty(this, "contact_delete_join", _descriptor97, this);
    _initializerDefineProperty(this, "product_delete", _descriptor98, this);
    _initializerDefineProperty(this, "product_delete_all", _descriptor99, this);
    _initializerDefineProperty(this, "product_delete_join", _descriptor100, this);
    _initializerDefineProperty(this, "project_delete", _descriptor101, this);
    _initializerDefineProperty(this, "project_delete_all", _descriptor102, this);
    _initializerDefineProperty(this, "project_delete_join", _descriptor103, this);
    _initializerDefineProperty(this, "event_delete", _descriptor104, this);
    _initializerDefineProperty(this, "event_delete_all", _descriptor105, this);
    _initializerDefineProperty(this, "event_delete_join", _descriptor106, this);
    _initializerDefineProperty(this, "workhour_delete", _descriptor107, this);
    _initializerDefineProperty(this, "workhour_delete_all", _descriptor108, this);
    _initializerDefineProperty(this, "workhour_delete_join", _descriptor109, this);
    _initializerDefineProperty(this, "estimate_delete", _descriptor110, this);
    _initializerDefineProperty(this, "estimate_delete_all", _descriptor111, this);
    _initializerDefineProperty(this, "estimate_delete_join", _descriptor112, this);
    _initializerDefineProperty(this, "invoice_delete", _descriptor113, this);
    _initializerDefineProperty(this, "invoice_delete_all", _descriptor114, this);
    _initializerDefineProperty(this, "invoice_delete_join", _descriptor115, this);
    _initializerDefineProperty(this, "expense_delete", _descriptor116, this);
    _initializerDefineProperty(this, "expense_delete_all", _descriptor117, this);
    _initializerDefineProperty(this, "expense_delete_join", _descriptor118, this);
    _initializerDefineProperty(this, "payment_delete", _descriptor119, this);
    _initializerDefineProperty(this, "payment_delete_all", _descriptor120, this);
    _initializerDefineProperty(this, "payment_delete_join", _descriptor121, this);
    _initializerDefineProperty(this, "contact_list", _descriptor122, this);
    _initializerDefineProperty(this, "contact_list_all", _descriptor123, this);
    _initializerDefineProperty(this, "contact_list_join", _descriptor124, this);
    _initializerDefineProperty(this, "product_list", _descriptor125, this);
    _initializerDefineProperty(this, "product_list_all", _descriptor126, this);
    _initializerDefineProperty(this, "product_list_join", _descriptor127, this);
    _initializerDefineProperty(this, "project_list", _descriptor128, this);
    _initializerDefineProperty(this, "project_list_all", _descriptor129, this);
    _initializerDefineProperty(this, "project_list_join", _descriptor130, this);
    _initializerDefineProperty(this, "event_list", _descriptor131, this);
    _initializerDefineProperty(this, "event_list_all", _descriptor132, this);
    _initializerDefineProperty(this, "event_list_join", _descriptor133, this);
    _initializerDefineProperty(this, "workhour_list", _descriptor134, this);
    _initializerDefineProperty(this, "workhour_list_all", _descriptor135, this);
    _initializerDefineProperty(this, "workhour_list_join", _descriptor136, this);
    _initializerDefineProperty(this, "estimate_list", _descriptor137, this);
    _initializerDefineProperty(this, "estimate_list_all", _descriptor138, this);
    _initializerDefineProperty(this, "estimate_list_join", _descriptor139, this);
    _initializerDefineProperty(this, "invoice_list", _descriptor140, this);
    _initializerDefineProperty(this, "invoice_list_all", _descriptor141, this);
    _initializerDefineProperty(this, "invoice_list_join", _descriptor142, this);
    _initializerDefineProperty(this, "expense_list", _descriptor143, this);
    _initializerDefineProperty(this, "expense_list_all", _descriptor144, this);
    _initializerDefineProperty(this, "expense_list_join", _descriptor145, this);
    _initializerDefineProperty(this, "payment_list", _descriptor146, this);
    _initializerDefineProperty(this, "payment_list_all", _descriptor147, this);
    _initializerDefineProperty(this, "payment_list_join", _descriptor148, this);
    _initializerDefineProperty(this, "contact_menu", _descriptor149, this);
    _initializerDefineProperty(this, "product_menu", _descriptor150, this);
    _initializerDefineProperty(this, "project_menu", _descriptor151, this);
    _initializerDefineProperty(this, "event_menu", _descriptor152, this);
    _initializerDefineProperty(this, "workhour_menu", _descriptor153, this);
    _initializerDefineProperty(this, "estimate_menu", _descriptor154, this);
    _initializerDefineProperty(this, "invoice_menu", _descriptor155, this);
    _initializerDefineProperty(this, "expense_menu", _descriptor156, this);
    _initializerDefineProperty(this, "payment_menu", _descriptor157, this);
    _initializerDefineProperty(this, "application", _descriptor158, this);
    _initializerDefineProperty(this, "redirect_page", _descriptor159, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor160, this);
  }
  get show_anagrafica() {
    return !this.show_contact_dati;
  }
  get disable_edit() {
    return !this.is_editable;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "role_name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "is_editable", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "is_erasable", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "is_show", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "is_admin", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "is_client", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "show_user_online", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "show_settings", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "totals_view", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "report_view", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "hide_account_settings", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "show_contact_dati", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hide_price_events", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "hide_compensi", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "hide_communication", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "contact_view", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "contact_view_all", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "contact_view_join", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "product_view_all", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "product_view", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "product_view_join", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "project_view", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "project_view_all", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "project_view_join", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "event_view", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "event_view_all", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "event_view_join", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "workhour_view", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "workhour_view_all", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "workhour_view_join", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "estimate_view", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "estimate_view_all", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "estimate_view_join", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "invoice_view", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "invoice_view_all", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "invoice_view_join", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "expense_view", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "expense_view_all", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "expense_view_join", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "payment_view", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "payment_view_all", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "payment_view_join", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "contact_insert", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "contact_insert_all", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "contact_insert_join", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "product_insert", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "product_insert_all", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "product_insert_join", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "project_insert", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "project_insert_all", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "project_insert_join", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "event_insert", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "event_insert_all", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "event_insert_join", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "workhour_insert", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "workhour_insert_all", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "workhour_insert_join", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "estimate_insert", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "estimate_insert_all", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "estimate_insert_join", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "invoice_insert", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "invoice_insert_all", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "invoice_insert_join", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "expense_insert", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "expense_insert_all", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "expense_insert_join", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "payment_insert", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "payment_insert_all", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "payment_insert_join", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "contact_edit", [_dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "contact_edit_all", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "contact_edit_join", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "product_edit", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "product_edit_all", [_dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "product_edit_join", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "project_edit", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "project_edit_all", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "project_edit_join", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "event_edit", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "event_edit_all", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "event_edit_join", [_dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "workhour_edit", [_dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "workhour_edit_all", [_dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "workhour_edit_join", [_dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "estimate_edit", [_dec83], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "estimate_edit_all", [_dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "estimate_edit_join", [_dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "invoice_edit", [_dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "invoice_edit_all", [_dec87], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "invoice_edit_join", [_dec88], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "expense_edit", [_dec89], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "expense_edit_all", [_dec90], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "expense_edit_join", [_dec91], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "payment_edit", [_dec92], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "payment_edit_all", [_dec93], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "payment_edit_join", [_dec94], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "contact_delete", [_dec95], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "contact_delete_all", [_dec96], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "contact_delete_join", [_dec97], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class.prototype, "product_delete", [_dec98], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class.prototype, "product_delete_all", [_dec99], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class.prototype, "product_delete_join", [_dec100], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class.prototype, "project_delete", [_dec101], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class.prototype, "project_delete_all", [_dec102], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class.prototype, "project_delete_join", [_dec103], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class.prototype, "event_delete", [_dec104], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class.prototype, "event_delete_all", [_dec105], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class.prototype, "event_delete_join", [_dec106], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class.prototype, "workhour_delete", [_dec107], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class.prototype, "workhour_delete_all", [_dec108], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor109 = _applyDecoratedDescriptor(_class.prototype, "workhour_delete_join", [_dec109], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor110 = _applyDecoratedDescriptor(_class.prototype, "estimate_delete", [_dec110], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor111 = _applyDecoratedDescriptor(_class.prototype, "estimate_delete_all", [_dec111], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor112 = _applyDecoratedDescriptor(_class.prototype, "estimate_delete_join", [_dec112], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor113 = _applyDecoratedDescriptor(_class.prototype, "invoice_delete", [_dec113], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor114 = _applyDecoratedDescriptor(_class.prototype, "invoice_delete_all", [_dec114], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor115 = _applyDecoratedDescriptor(_class.prototype, "invoice_delete_join", [_dec115], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor116 = _applyDecoratedDescriptor(_class.prototype, "expense_delete", [_dec116], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor117 = _applyDecoratedDescriptor(_class.prototype, "expense_delete_all", [_dec117], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor118 = _applyDecoratedDescriptor(_class.prototype, "expense_delete_join", [_dec118], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor119 = _applyDecoratedDescriptor(_class.prototype, "payment_delete", [_dec119], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor120 = _applyDecoratedDescriptor(_class.prototype, "payment_delete_all", [_dec120], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor121 = _applyDecoratedDescriptor(_class.prototype, "payment_delete_join", [_dec121], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor122 = _applyDecoratedDescriptor(_class.prototype, "contact_list", [_dec122], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor123 = _applyDecoratedDescriptor(_class.prototype, "contact_list_all", [_dec123], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor124 = _applyDecoratedDescriptor(_class.prototype, "contact_list_join", [_dec124], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor125 = _applyDecoratedDescriptor(_class.prototype, "product_list", [_dec125], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor126 = _applyDecoratedDescriptor(_class.prototype, "product_list_all", [_dec126], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor127 = _applyDecoratedDescriptor(_class.prototype, "product_list_join", [_dec127], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor128 = _applyDecoratedDescriptor(_class.prototype, "project_list", [_dec128], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor129 = _applyDecoratedDescriptor(_class.prototype, "project_list_all", [_dec129], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor130 = _applyDecoratedDescriptor(_class.prototype, "project_list_join", [_dec130], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor131 = _applyDecoratedDescriptor(_class.prototype, "event_list", [_dec131], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor132 = _applyDecoratedDescriptor(_class.prototype, "event_list_all", [_dec132], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor133 = _applyDecoratedDescriptor(_class.prototype, "event_list_join", [_dec133], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor134 = _applyDecoratedDescriptor(_class.prototype, "workhour_list", [_dec134], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor135 = _applyDecoratedDescriptor(_class.prototype, "workhour_list_all", [_dec135], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor136 = _applyDecoratedDescriptor(_class.prototype, "workhour_list_join", [_dec136], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor137 = _applyDecoratedDescriptor(_class.prototype, "estimate_list", [_dec137], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor138 = _applyDecoratedDescriptor(_class.prototype, "estimate_list_all", [_dec138], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor139 = _applyDecoratedDescriptor(_class.prototype, "estimate_list_join", [_dec139], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor140 = _applyDecoratedDescriptor(_class.prototype, "invoice_list", [_dec140], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor141 = _applyDecoratedDescriptor(_class.prototype, "invoice_list_all", [_dec141], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor142 = _applyDecoratedDescriptor(_class.prototype, "invoice_list_join", [_dec142], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor143 = _applyDecoratedDescriptor(_class.prototype, "expense_list", [_dec143], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor144 = _applyDecoratedDescriptor(_class.prototype, "expense_list_all", [_dec144], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor145 = _applyDecoratedDescriptor(_class.prototype, "expense_list_join", [_dec145], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor146 = _applyDecoratedDescriptor(_class.prototype, "payment_list", [_dec146], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor147 = _applyDecoratedDescriptor(_class.prototype, "payment_list_all", [_dec147], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor148 = _applyDecoratedDescriptor(_class.prototype, "payment_list_join", [_dec148], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor149 = _applyDecoratedDescriptor(_class.prototype, "contact_menu", [_dec149], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor150 = _applyDecoratedDescriptor(_class.prototype, "product_menu", [_dec150], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor151 = _applyDecoratedDescriptor(_class.prototype, "project_menu", [_dec151], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor152 = _applyDecoratedDescriptor(_class.prototype, "event_menu", [_dec152], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor153 = _applyDecoratedDescriptor(_class.prototype, "workhour_menu", [_dec153], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor154 = _applyDecoratedDescriptor(_class.prototype, "estimate_menu", [_dec154], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor155 = _applyDecoratedDescriptor(_class.prototype, "invoice_menu", [_dec155], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor156 = _applyDecoratedDescriptor(_class.prototype, "expense_menu", [_dec156], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor157 = _applyDecoratedDescriptor(_class.prototype, "payment_menu", [_dec157], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor158 = _applyDecoratedDescriptor(_class.prototype, "application", [_dec158], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor159 = _applyDecoratedDescriptor(_class.prototype, "redirect_page", [_dec159], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor160 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec160], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { RoleModel as default };
//# sourceMappingURL=role.js.map
